import React, { useState } from "react";
import { Typography } from "@material-ui/core";


const MessageAtom = (props) => {

    const [more, setMore] = useState(true);

    return (
        <>
            {props.message && props.message.length > props.len ?
                <>
                    {more ?
                        <Typography variant="caption">
                            {props.message.substring(0, props.len - 4)}
                            <span onClick={() => setMore(!more)} style={{ color: "blue" }}>...Read More</span>
                        </Typography> :
                        <Typography variant="caption">
                            {props.message}
                            <span onClick={() => setMore(!more)} style={{ color: "blue" }}> Read Less</span>
                        </Typography>
                    }
                </>
                :
                <Typography variant="caption">
                    {props.message}
                </Typography>
            }
        </>
    );
};

export default MessageAtom;